import { ComponentProps } from 'react'

import { ContentfulPageBannerSection } from '../../app/_components/pages/contentful/sections/ContentfulPageBannerSection.client'
import { ContentfulPageHeroSection } from '../../app/_components/pages/contentful/sections/ContentfulPageHeroSection.client'
import { ContentfulPageRawHtmlSection } from '../../app/_components/pages/contentful/sections/ContentfulPageRawHtmlSection.client'
import { ContentfulPageTileSection } from '../../app/_components/pages/contentful/sections/ContentfulPageTileSection.client'

type PageSectionModel =
  | ComponentProps<typeof ContentfulPageBannerSection>['data']
  | ComponentProps<typeof ContentfulPageHeroSection>['data']
  | ComponentProps<typeof ContentfulPageTileSection>['data']
  | ComponentProps<typeof ContentfulPageRawHtmlSection>['data']

type PageSectionProps = {
  /** The Contentful Gateway Model used to generate a Contentful Component Section. */
  sectionModel: PageSectionModel
  /** The index defining what section of the page this is. Leave empty if you are unsure. First sections of the page get preloaded images. */
  index: number
}

function renderPageSection(props: PageSectionModel, index: number): JSX.Element | null {
  switch (props.__typename) {
    case 'PageBannerSection':
      return <ContentfulPageBannerSection data={props} pageSectionIndex={index} />
    case 'PageHeroSection':
      return <ContentfulPageHeroSection data={props} pageSectionIndex={index} />
    case 'PageTileSection':
      return <ContentfulPageTileSection data={props} pageSectionIndex={index} />
    case 'RawHtmlSection':
      return <ContentfulPageRawHtmlSection data={props} />
    default:
      return null
  }
}

export const PageSection = ({ sectionModel, index }: PageSectionProps) => {
  return renderPageSection(sectionModel, index)
}
